/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TokenImport } from './routes/token'
import { Route as SignInImport } from './routes/sign-in'
import { Route as MyPageImport } from './routes/my-page'
import { Route as MeetupImport } from './routes/meetup'
import { Route as ContactImport } from './routes/contact'
import { Route as AdminRouteImport } from './routes/admin/route'
import { Route as IndexImport } from './routes/index'
import { Route as BookingIndexImport } from './routes/booking/index'
import { Route as AboutIndexImport } from './routes/about/index'
import { Route as BookingBookingIdImport } from './routes/booking/$bookingId'
import { Route as AdminMemberImport } from './routes/admin/member'
import { Route as AboutMeetupImport } from './routes/about/meetup'
import { Route as AboutLocationImport } from './routes/about/location'
import { Route as AdminMeetupIndexImport } from './routes/admin/meetup/index'
import { Route as AdminBookingIndexImport } from './routes/admin/booking/index'
import { Route as AdminMeetupCreateImport } from './routes/admin/meetup/create'
import { Route as AdminMeetupMeetupIdImport } from './routes/admin/meetup/$meetupId'
import { Route as AdminBookingBookingIdImport } from './routes/admin/booking/$bookingId'

// Create/Update Routes

const TokenRoute = TokenImport.update({
  id: '/token',
  path: '/token',
  getParentRoute: () => rootRoute,
} as any)

const SignInRoute = SignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const MyPageRoute = MyPageImport.update({
  id: '/my-page',
  path: '/my-page',
  getParentRoute: () => rootRoute,
} as any)

const MeetupRoute = MeetupImport.update({
  id: '/meetup',
  path: '/meetup',
  getParentRoute: () => rootRoute,
} as any)

const ContactRoute = ContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRoute,
} as any)

const AdminRouteRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const BookingIndexRoute = BookingIndexImport.update({
  id: '/booking/',
  path: '/booking/',
  getParentRoute: () => rootRoute,
} as any)

const AboutIndexRoute = AboutIndexImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => rootRoute,
} as any)

const BookingBookingIdRoute = BookingBookingIdImport.update({
  id: '/booking/$bookingId',
  path: '/booking/$bookingId',
  getParentRoute: () => rootRoute,
} as any)

const AdminMemberRoute = AdminMemberImport.update({
  id: '/member',
  path: '/member',
  getParentRoute: () => AdminRouteRoute,
} as any)

const AboutMeetupRoute = AboutMeetupImport.update({
  id: '/about/meetup',
  path: '/about/meetup',
  getParentRoute: () => rootRoute,
} as any)

const AboutLocationRoute = AboutLocationImport.update({
  id: '/about/location',
  path: '/about/location',
  getParentRoute: () => rootRoute,
} as any)

const AdminMeetupIndexRoute = AdminMeetupIndexImport.update({
  id: '/meetup/',
  path: '/meetup/',
  getParentRoute: () => AdminRouteRoute,
} as any)

const AdminBookingIndexRoute = AdminBookingIndexImport.update({
  id: '/booking/',
  path: '/booking/',
  getParentRoute: () => AdminRouteRoute,
} as any)

const AdminMeetupCreateRoute = AdminMeetupCreateImport.update({
  id: '/meetup/create',
  path: '/meetup/create',
  getParentRoute: () => AdminRouteRoute,
} as any)

const AdminMeetupMeetupIdRoute = AdminMeetupMeetupIdImport.update({
  id: '/meetup/$meetupId',
  path: '/meetup/$meetupId',
  getParentRoute: () => AdminRouteRoute,
} as any)

const AdminBookingBookingIdRoute = AdminBookingBookingIdImport.update({
  id: '/booking/$bookingId',
  path: '/booking/$bookingId',
  getParentRoute: () => AdminRouteRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactImport
      parentRoute: typeof rootRoute
    }
    '/meetup': {
      id: '/meetup'
      path: '/meetup'
      fullPath: '/meetup'
      preLoaderRoute: typeof MeetupImport
      parentRoute: typeof rootRoute
    }
    '/my-page': {
      id: '/my-page'
      path: '/my-page'
      fullPath: '/my-page'
      preLoaderRoute: typeof MyPageImport
      parentRoute: typeof rootRoute
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInImport
      parentRoute: typeof rootRoute
    }
    '/token': {
      id: '/token'
      path: '/token'
      fullPath: '/token'
      preLoaderRoute: typeof TokenImport
      parentRoute: typeof rootRoute
    }
    '/about/location': {
      id: '/about/location'
      path: '/about/location'
      fullPath: '/about/location'
      preLoaderRoute: typeof AboutLocationImport
      parentRoute: typeof rootRoute
    }
    '/about/meetup': {
      id: '/about/meetup'
      path: '/about/meetup'
      fullPath: '/about/meetup'
      preLoaderRoute: typeof AboutMeetupImport
      parentRoute: typeof rootRoute
    }
    '/admin/member': {
      id: '/admin/member'
      path: '/member'
      fullPath: '/admin/member'
      preLoaderRoute: typeof AdminMemberImport
      parentRoute: typeof AdminRouteImport
    }
    '/booking/$bookingId': {
      id: '/booking/$bookingId'
      path: '/booking/$bookingId'
      fullPath: '/booking/$bookingId'
      preLoaderRoute: typeof BookingBookingIdImport
      parentRoute: typeof rootRoute
    }
    '/about/': {
      id: '/about/'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutIndexImport
      parentRoute: typeof rootRoute
    }
    '/booking/': {
      id: '/booking/'
      path: '/booking'
      fullPath: '/booking'
      preLoaderRoute: typeof BookingIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/booking/$bookingId': {
      id: '/admin/booking/$bookingId'
      path: '/booking/$bookingId'
      fullPath: '/admin/booking/$bookingId'
      preLoaderRoute: typeof AdminBookingBookingIdImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/meetup/$meetupId': {
      id: '/admin/meetup/$meetupId'
      path: '/meetup/$meetupId'
      fullPath: '/admin/meetup/$meetupId'
      preLoaderRoute: typeof AdminMeetupMeetupIdImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/meetup/create': {
      id: '/admin/meetup/create'
      path: '/meetup/create'
      fullPath: '/admin/meetup/create'
      preLoaderRoute: typeof AdminMeetupCreateImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/booking/': {
      id: '/admin/booking/'
      path: '/booking'
      fullPath: '/admin/booking'
      preLoaderRoute: typeof AdminBookingIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/meetup/': {
      id: '/admin/meetup/'
      path: '/meetup'
      fullPath: '/admin/meetup'
      preLoaderRoute: typeof AdminMeetupIndexImport
      parentRoute: typeof AdminRouteImport
    }
  }
}

// Create and export the route tree

interface AdminRouteRouteChildren {
  AdminMemberRoute: typeof AdminMemberRoute
  AdminBookingBookingIdRoute: typeof AdminBookingBookingIdRoute
  AdminMeetupMeetupIdRoute: typeof AdminMeetupMeetupIdRoute
  AdminMeetupCreateRoute: typeof AdminMeetupCreateRoute
  AdminBookingIndexRoute: typeof AdminBookingIndexRoute
  AdminMeetupIndexRoute: typeof AdminMeetupIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminMemberRoute: AdminMemberRoute,
  AdminBookingBookingIdRoute: AdminBookingBookingIdRoute,
  AdminMeetupMeetupIdRoute: AdminMeetupMeetupIdRoute,
  AdminMeetupCreateRoute: AdminMeetupCreateRoute,
  AdminBookingIndexRoute: AdminBookingIndexRoute,
  AdminMeetupIndexRoute: AdminMeetupIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/contact': typeof ContactRoute
  '/meetup': typeof MeetupRoute
  '/my-page': typeof MyPageRoute
  '/sign-in': typeof SignInRoute
  '/token': typeof TokenRoute
  '/about/location': typeof AboutLocationRoute
  '/about/meetup': typeof AboutMeetupRoute
  '/admin/member': typeof AdminMemberRoute
  '/booking/$bookingId': typeof BookingBookingIdRoute
  '/about': typeof AboutIndexRoute
  '/booking': typeof BookingIndexRoute
  '/admin/booking/$bookingId': typeof AdminBookingBookingIdRoute
  '/admin/meetup/$meetupId': typeof AdminMeetupMeetupIdRoute
  '/admin/meetup/create': typeof AdminMeetupCreateRoute
  '/admin/booking': typeof AdminBookingIndexRoute
  '/admin/meetup': typeof AdminMeetupIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/contact': typeof ContactRoute
  '/meetup': typeof MeetupRoute
  '/my-page': typeof MyPageRoute
  '/sign-in': typeof SignInRoute
  '/token': typeof TokenRoute
  '/about/location': typeof AboutLocationRoute
  '/about/meetup': typeof AboutMeetupRoute
  '/admin/member': typeof AdminMemberRoute
  '/booking/$bookingId': typeof BookingBookingIdRoute
  '/about': typeof AboutIndexRoute
  '/booking': typeof BookingIndexRoute
  '/admin/booking/$bookingId': typeof AdminBookingBookingIdRoute
  '/admin/meetup/$meetupId': typeof AdminMeetupMeetupIdRoute
  '/admin/meetup/create': typeof AdminMeetupCreateRoute
  '/admin/booking': typeof AdminBookingIndexRoute
  '/admin/meetup': typeof AdminMeetupIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/contact': typeof ContactRoute
  '/meetup': typeof MeetupRoute
  '/my-page': typeof MyPageRoute
  '/sign-in': typeof SignInRoute
  '/token': typeof TokenRoute
  '/about/location': typeof AboutLocationRoute
  '/about/meetup': typeof AboutMeetupRoute
  '/admin/member': typeof AdminMemberRoute
  '/booking/$bookingId': typeof BookingBookingIdRoute
  '/about/': typeof AboutIndexRoute
  '/booking/': typeof BookingIndexRoute
  '/admin/booking/$bookingId': typeof AdminBookingBookingIdRoute
  '/admin/meetup/$meetupId': typeof AdminMeetupMeetupIdRoute
  '/admin/meetup/create': typeof AdminMeetupCreateRoute
  '/admin/booking/': typeof AdminBookingIndexRoute
  '/admin/meetup/': typeof AdminMeetupIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/contact'
    | '/meetup'
    | '/my-page'
    | '/sign-in'
    | '/token'
    | '/about/location'
    | '/about/meetup'
    | '/admin/member'
    | '/booking/$bookingId'
    | '/about'
    | '/booking'
    | '/admin/booking/$bookingId'
    | '/admin/meetup/$meetupId'
    | '/admin/meetup/create'
    | '/admin/booking'
    | '/admin/meetup'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/contact'
    | '/meetup'
    | '/my-page'
    | '/sign-in'
    | '/token'
    | '/about/location'
    | '/about/meetup'
    | '/admin/member'
    | '/booking/$bookingId'
    | '/about'
    | '/booking'
    | '/admin/booking/$bookingId'
    | '/admin/meetup/$meetupId'
    | '/admin/meetup/create'
    | '/admin/booking'
    | '/admin/meetup'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/contact'
    | '/meetup'
    | '/my-page'
    | '/sign-in'
    | '/token'
    | '/about/location'
    | '/about/meetup'
    | '/admin/member'
    | '/booking/$bookingId'
    | '/about/'
    | '/booking/'
    | '/admin/booking/$bookingId'
    | '/admin/meetup/$meetupId'
    | '/admin/meetup/create'
    | '/admin/booking/'
    | '/admin/meetup/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  ContactRoute: typeof ContactRoute
  MeetupRoute: typeof MeetupRoute
  MyPageRoute: typeof MyPageRoute
  SignInRoute: typeof SignInRoute
  TokenRoute: typeof TokenRoute
  AboutLocationRoute: typeof AboutLocationRoute
  AboutMeetupRoute: typeof AboutMeetupRoute
  BookingBookingIdRoute: typeof BookingBookingIdRoute
  AboutIndexRoute: typeof AboutIndexRoute
  BookingIndexRoute: typeof BookingIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  ContactRoute: ContactRoute,
  MeetupRoute: MeetupRoute,
  MyPageRoute: MyPageRoute,
  SignInRoute: SignInRoute,
  TokenRoute: TokenRoute,
  AboutLocationRoute: AboutLocationRoute,
  AboutMeetupRoute: AboutMeetupRoute,
  BookingBookingIdRoute: BookingBookingIdRoute,
  AboutIndexRoute: AboutIndexRoute,
  BookingIndexRoute: BookingIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/admin",
        "/contact",
        "/meetup",
        "/my-page",
        "/sign-in",
        "/token",
        "/about/location",
        "/about/meetup",
        "/booking/$bookingId",
        "/about/",
        "/booking/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/admin": {
      "filePath": "admin/route.tsx",
      "children": [
        "/admin/member",
        "/admin/booking/$bookingId",
        "/admin/meetup/$meetupId",
        "/admin/meetup/create",
        "/admin/booking/",
        "/admin/meetup/"
      ]
    },
    "/contact": {
      "filePath": "contact.tsx"
    },
    "/meetup": {
      "filePath": "meetup.tsx"
    },
    "/my-page": {
      "filePath": "my-page.tsx"
    },
    "/sign-in": {
      "filePath": "sign-in.tsx"
    },
    "/token": {
      "filePath": "token.tsx"
    },
    "/about/location": {
      "filePath": "about/location.tsx"
    },
    "/about/meetup": {
      "filePath": "about/meetup.tsx"
    },
    "/admin/member": {
      "filePath": "admin/member.tsx",
      "parent": "/admin"
    },
    "/booking/$bookingId": {
      "filePath": "booking/$bookingId.tsx"
    },
    "/about/": {
      "filePath": "about/index.tsx"
    },
    "/booking/": {
      "filePath": "booking/index.tsx"
    },
    "/admin/booking/$bookingId": {
      "filePath": "admin/booking/$bookingId.tsx",
      "parent": "/admin"
    },
    "/admin/meetup/$meetupId": {
      "filePath": "admin/meetup/$meetupId.tsx",
      "parent": "/admin"
    },
    "/admin/meetup/create": {
      "filePath": "admin/meetup/create.tsx",
      "parent": "/admin"
    },
    "/admin/booking/": {
      "filePath": "admin/booking/index.tsx",
      "parent": "/admin"
    },
    "/admin/meetup/": {
      "filePath": "admin/meetup/index.tsx",
      "parent": "/admin"
    }
  }
}
ROUTE_MANIFEST_END */
